import { render, staticRenderFns } from "./InvestorPreviewResponseFile.vue?vue&type=template&id=6d2d0f10&"
import script from "./InvestorPreviewResponseFile.vue?vue&type=script&lang=js&"
export * from "./InvestorPreviewResponseFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports